import dynamic from "next/dynamic";
import IconWithParagraphGridConfig from "./icon-with-paragraph-grid-config";
import IconWithParagraphGridAdvancedConfig from "./icon-with-paragraph-grid-advanced-config";
const IconWithParagraphGridComponent = dynamic(()=>import("./icon-with-paragraph-grid-component"));
export default {
    IconWithParagraphGridComponent,
    IconWithParagraphGridConfig,
    IconWithParagraphGridAdvancedConfig
};
